// src/Services/patientService.js
import apiClient from "../api/apiClient";

/**
 * Fetch minimal table data for OPD / Patients listing.
 * @param {Object} params
 * @param {string} [params.tab] - 'all' | 'opd' | 'ipd' | 'emergency' | 'abha'
 * @param {string} [params.search] - Search by Name, Mobile, UHID, Doctor, ABHA
 * @param {number} [params.page=1]
 * @param {number} [params.limit=50]
 * @returns {Promise<Object>} Response containing { status, data: { patients, total }, pagination }
 */
export const getPatientsAll = async ({
  tab = "all",
  search = "",
  page = 1,
  limit = 50,
} = {}) => {
  const params = { page, limit };
  if (tab && tab.toLowerCase() !== "all") {
    params.tab = tab.toLowerCase();
  }
  if (search && search.trim()) {
    params.search = search.trim();
  }

  const response = await apiClient.get("/api/patients/all", { params });
  return response.data;
};

/**
 * Fetch complete, rich patient details when row is clicked or drawer opened.
 * @param {string} patientIdOrUhid - MongoDB _id or UHID
 * @returns {Promise<Object>} Full profile + chronologically sorted visits (newest first)
 */
export const getPatientById = async (patientIdOrUhid) => {
  if (!patientIdOrUhid) {
    throw new Error("patientIdOrUhid is required to fetch patient details.");
  }
  const response = await apiClient.get(
    `/api/patient/${encodeURIComponent(patientIdOrUhid)}`,
  );
  const data = response.data?.data !== undefined ? response.data.data : response.data;
  if (data && typeof data === "object") {
    return {
      ...data,
      id: data._id || data.id,
      fullName: data.name || data.fullName,
      maskedAadhaar: data.maskedAadhaar || data.aadhaarNumber || data.aadhaar_masked || "",
      maskedAbha: data.maskedAbha || data.formattedAbhaId || (data.abhaNumber ? `**** ${String(data.abhaNumber).slice(-4)}` : ""),
      abhaAddress: data.abhaAddress || data.ABHAAddress || data.abhaaddress || "",
      isAbhaLinked: Boolean(data.isAbhaLinked),
    };
  }
  return data;
};

export default {
  getPatientsAll,
  getPatientById,
};
